export const downloadFile = async (imgUrl, filename = 'downloaded-file', matrixClient, dispatch) => {
    try {
        console.log('🔄 Starting file download...');
        console.log('📍 Original URL:', imgUrl);
        
        // Show download started notification
        dispatch({
            type: 'setSuccessMsg',
            payload: 'Downloading file...'
        });
        
        let downloadUrl;
        let useAuth = true;
        
        // Check if it's an MXC URL or HTTP URL
        if (imgUrl.startsWith('mxc://')) {
            console.log('📋 Processing MXC URL');
            
            // Extract server name and media ID from MXC URL
            const mxcPath = imgUrl.replace('mxc://', '');
            const pathParts = mxcPath.split('/');
            
            if (pathParts.length < 2) {
                throw new Error('Invalid MXC URL structure');
            }
            
            const serverName = pathParts[0];
            const mediaId = pathParts[1];
            const homeserverUrl = matrixClient.getHomeserverUrl();
            
            console.log('🔧 Extracted components:', {
                serverName,
                mediaId,
                homeserverUrl
            });
            
            // Use the Matrix media download URL format
            downloadUrl = `${homeserverUrl}/_matrix/media/v3/download/${serverName}/${mediaId}`;
            console.log('📥 Matrix download URL:', downloadUrl);
            
        } else if (imgUrl.startsWith('http://') || imgUrl.startsWith('https://')) {
            console.log('📋 Processing HTTP URL');
            downloadUrl = imgUrl;
            useAuth = true;
        } else {
            throw new Error('Invalid URL format. Expected MXC or HTTP URL.');
        }
        
        console.log('🔄 Fetching file from:', downloadUrl);
        
        const response = await fetch(downloadUrl, {
            headers: useAuth ? {
                'Authorization': `Bearer ${matrixClient.getAccessToken()}`,
            } : {},
        });
        
        console.log('📡 Response status:', response.status);
        
        if (response.ok) {
            console.log('✅ Download successful!');
            const blob = await response.blob();
            triggerFileDownload(blob, filename, dispatch);
            return;
        } else {
            console.log('❌ Download failed with status:', response.status);
            const errorText = await response.text();
            console.log('Error response:', errorText);
        }
        
        throw new Error(`Download failed. The media server may not be properly configured or the file may not exist.`);
        
    } catch (error) {
        console.error('❌ Error downloading file:', error);
        
        // Show error notification with more specific message
        dispatch({
            type: 'setErrorMsg',
            payload: `Download failed: ${error.message}. Please check your Matrix server configuration.`
        });
        
        // Clear error notification after 5 seconds
        setTimeout(() => {
            dispatch({
                type: 'setErrorMsg',
                payload: null
            });
        }, 5000);
    }
};

// Track revoked URLs to make cleanup idempotent
const revokedDownloadUrls = new Set();

const triggerFileDownload = (blob, filename, dispatch) => {
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    
    // Extract file extension from filename or use appropriate extension
    const fileExtension = filename.includes('.') ? filename.split('.').pop() : 'bin';
    const downloadFilename = filename.includes('.') ? filename : `downloaded-file.${fileExtension}`;
    
    link.download = downloadFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up object URL with idempotent error handling
    try {
        if (!revokedDownloadUrls.has(url)) {
            window.URL.revokeObjectURL(url);
            revokedDownloadUrls.add(url);
        }
    } catch (error) {
        console.warn('Error revoking object URL:', error);
    }
    
    // Show success notification
    const fileType = filename.includes('.') ? filename.split('.').pop().toUpperCase() : 'FILE';
    dispatch({
        type: 'setSuccessMsg',
        payload: `${fileType} file downloaded successfully!`
    });
    
    setTimeout(() => {
        dispatch({
            type: 'setSuccessMsg',
            payload: null
        });
    }, 3000);
};
